export const SKILLS_SETTINGS_PATH = '/settings/organization/skills';
